export default {
    _beach_drop_in: 'beach_drop_in',
    _beach_jingle: 'beach_jingle',
    _beach_jump_up_: 'beach_jump_up_',
    _button_tween: 'button_tween',
    _campground_drop_in: 'campground_drop_in',
    _campground_jingle: 'campground_jingle',
    _campground_jump_up: 'campground_jump_up',
    _circle: 'circle',
    _city_drop_in: 'city_drop_in',
    _city_jingle: 'city_jingle',
    _city_jump_up: 'city_jump_up',
    _click_on_different_parts_of_screen: 'click-on-different-parts-of-screen',
    _click: 'click',
    _cone: 'cone',
    _crescent: 'crescent',
    _cube: 'cube',
    _cylinder: 'cylinder',
    _find_shape: 'find_shape',
    _get_in_shape: 'get-in-shape',
    _great_work: 'great_work',
    _heart: 'heart',
    _hexagon: 'hexagon',
    _locate_that_shape: 'locate-that-shape',
    _octagon: 'octagon',
    _oval: 'oval',
    _pentagon: 'pentagon',
    _pyramid: 'pyramid',
    _rectangle: 'rectangle',
    _rectangluar_prism: 'rectangluar-prism',
    _select_shape: 'select_shape',
    _select_shape_from_list: 'select-shape-from-list',
    _shapes_review_tween: 'shapes_review_tween',
    _space_drop_in: 'space_drop_in',
    _space_jingle: 'space_jingle',
    _space_jump_up: 'space_jump_up',
    _sphere: 'sphere',
    _square: 'square',
    _title_drop_in: 'title_drop_in',
    _title_jingle: 'title_jingle',
    _title_jump_up: 'title_jump_up',
    _triangle: 'triangle',
    _triangular_prism: 'triangular-prism',
    _unlock_new_scene: 'unlock_new_scene',
    _zoom_in: 'zoom_in',
    _zoom_out: 'zoom_out',
}